import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';
import DisplayWithSelectionModal from "VuePartials/Artwork/DisplayWithSelectionModal";

export default {
  components: {
    VjsModal,
    DisplayWithSelectionModal,
  },
  mixins: [VjsModalMixin],
  computed: {
    can_confirm() {
      return true;
    },
  },
  methods: {
    close() {
      this.$modal.hide(this.name);
    },
    searchableLabel({ group, role }) {
      return `${group} : ${role}`;
    },
    pushSelection(chosen_taxonomy) {
      this.person.role = chosen_taxonomy['role'];
      this.person.group = chosen_taxonomy['group'];
    },
  },
};
